import { render, staticRenderFns } from "./DetailsTableWidget.vue?vue&type=template&id=564428c2&scoped=true&"
import script from "./DetailsTableWidget.vue?vue&type=script&lang=js&"
export * from "./DetailsTableWidget.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTableWidget.vue?vue&type=style&index=0&id=564428c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564428c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564428c2')) {
      api.createRecord('564428c2', component.options)
    } else {
      api.reload('564428c2', component.options)
    }
    module.hot.accept("./DetailsTableWidget.vue?vue&type=template&id=564428c2&scoped=true&", function () {
      api.rerender('564428c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/DetailsTableWidget.vue"
export default component.exports